import { AnyAction } from 'redux';

import { InternalActionTypes } from '../constants/actionTypes';
import { ModalId } from '../constants/modalId';

export interface OpenModalAction extends AnyAction {
  type: InternalActionTypes.OpenModal;
  modalId: ModalId;
  modalProps?: any;
}

export interface CloseModalAction extends AnyAction {
  type: InternalActionTypes.CloseModal;
  modalId: ModalId;
}

export function createModalOpenAction(modalId: ModalId, modalProps?: any): OpenModalAction {
  return {
    modalId,
    modalProps,
    type: InternalActionTypes.OpenModal,
  };
}

export function createModalCloseAction(modalId: ModalId): CloseModalAction {
  return {
    modalId,
    type: InternalActionTypes.CloseModal,
  };
}
